// Spanish/English toggle button.
import { useLang } from "@/i18n";

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  const opts = [["es", "🇳🇮", "ES"], ["en", "🇺🇸", "EN"]];
  return (
    <div className={`flex rounded-xl overflow-hidden ring-2 ring-[#FFEB3B]/60 ${className}`} data-testid="lang-toggle" style={{ boxShadow: "0 6px 16px rgba(0,0,0,0.35)" }}>
      {opts.map(([l, flag, label]) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className="font-pixel text-xs px-3.5 py-2 transition-colors flex items-center gap-1.5"
          style={{ background: lang === l ? "#FF5722" : "rgba(20,20,20,0.85)", color: "#fff" }}
          aria-pressed={lang === l}
        >
          <span className="text-sm leading-none" aria-hidden>{flag}</span>{label}
        </button>
      ))}
    </div>
  );
};
